import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import AvatarFunc from '../components/AvatarFunc';
import BarraProgresso from '../components/BarraProgresso';
import { useAuth } from '../contexts/AuthContext';
import api from '../api';

function haQuanto(d) {
  if (!d) return 'nunca acessou';
  const dias = Math.floor((Date.now() - new Date(d).getTime()) / 86400000);
  if (dias <= 0) return 'acessou hoje';
  if (dias === 1) return 'acessou ontem';
  if (dias < 30) return `acessou há ${dias} dias`;
  return `último acesso em ${new Date(d).toLocaleDateString('pt-BR')}`;
}

export default function EquipeFuncionario() {
  const { id } = useParams();
  const { token } = useAuth();
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    setCarregando(true);
    api.get(`/equipe/${id}`)
      .then(({ data }) => setDados(data))
      .catch(err => setErro(err.response?.data?.error || 'Erro ao carregar'))
      .finally(() => setCarregando(false));
  }, [id]);

  const f = dados?.funcionario;
  const pendentesLeitura = (dados?.leituras || []).filter(l => !l.lido).length;

  return (
    <>
      <Header />
      <main className="conteudo-container" style={{ maxWidth: 760 }}>
        <Link to="/equipe" className="doc-voltar"><i className="bi bi-arrow-left"></i> Minha Equipe</Link>
        {carregando && <div>Carregando…</div>}
        {erro && <div className="erro">{erro}</div>}

        {f && (
          <>
            <div className="equipe-det-cab">
              <AvatarFunc id={f.id} nome={f.nome} temFoto={f.tem_foto} token={token} size={56} />
              <div>
                <h1 style={{ margin: 0, fontSize: '1.4rem' }}>{f.nome}</h1>
                <div className="equipe-sub">{f.cargo || 'sem cargo'} · Filial {f.filial}</div>
                <div className="equipe-acesso" style={{ marginTop: 4 }}><i className="bi bi-clock-history"></i> {haQuanto(f.ultimo_login)}</div>
              </div>
            </div>

            <h2 className="trilha-secao">Trilhas</h2>
            {dados.trilhas.length === 0 && <div className="equipe-vazio">Nenhuma trilha atribuída a este cargo.</div>}
            {dados.trilhas.map(t => (
              <div className="equipe-trilha" key={t.id}>
                <div className="equipe-trilha-cab">
                  <span className="equipe-trilha-titulo">{t.titulo}</span>
                  <span className={`equipe-trilha-pct${t.pct === 100 ? ' equipe-trilha-pct--ok' : ''}`}>{t.pct}%</span>
                </div>
                <BarraProgresso pct={t.pct} />
                <div className="equipe-itens">
                  {t.itens.map((i, idx) => (
                    <div className="equipe-item" key={idx}>
                      <i className={`bi ${i.tipo === 'quiz' ? 'bi-patch-question' : 'bi-file-earmark-text'} equipe-item-icone`}></i>
                      <span className="equipe-item-titulo">{i.titulo}</span>
                      {i.concluido
                        ? <span className="equipe-item-ok"><i className="bi bi-check-circle-fill"></i> {i.nota != null ? `nota ${i.nota}` : 'feito'}</span>
                        : <span className="equipe-item-pend">pendente</span>}
                    </div>
                  ))}
                </div>
              </div>
            ))}

            <h2 className="trilha-secao">Leituras obrigatórias {pendentesLeitura > 0 && <span className="equipe-pend-tag">{pendentesLeitura} pendente{pendentesLeitura > 1 ? 's' : ''}</span>}</h2>
            {dados.leituras.length === 0 && <div className="equipe-vazio">Nenhuma leitura obrigatória pra este cargo.</div>}
            <div className="equipe-leituras">
              {dados.leituras.map(l => (
                <div className="equipe-leitura" key={l.id}>
                  <i className={`bi ${l.lido ? 'bi-check-circle-fill equipe-leitura-ok' : 'bi-circle equipe-leitura-pend'}`}></i>
                  <span className="equipe-item-titulo">{l.titulo}</span>
                  <span className="equipe-leitura-data">
                    {l.lido ? (l.lido_em ? new Date(l.lido_em).toLocaleDateString('pt-BR') : 'lido') : 'pendente'}
                  </span>
                </div>
              ))}
            </div>
          </>
        )}
      </main>
    </>
  );
}
